<div class="apg-loading" *ngIf="loading">
  <p>Verifying...</p>
  <ion-spinner></ion-spinner>
</div>

<div class="apg-panel page" *ngIf="!loading && page" [appScrollIntoView]="page">
  <form #questionForm="ngForm">
    <div class="title" *ngIf="page.showHeader">{{page.title}}</div>
    <div class="comment" *ngIf="page.comment">{{page.comment?.text}}</div>
    <div class="cube">
      <div class="filler"></div>

      <div class="questions">
        <ng-container *ngFor="let question of questionnaire.currentPage.questions">
          <div *ngIf="question.visible" class="question">
            <div class="separator" *ngIf="question.type === 'ImageSelect'"></div>

            <ng-container [ngSwitch]="question.type">

              <app-site-content *ngSwitchCase="'SiteContent'" [key]="question.key" [data]="answers">
              </app-site-content>

              <app-question *ngSwitchDefault [question]="question"
                [showHeader]="page.questions.length &gt; 1 || page.questions.length === 1">
              </app-question>

            </ng-container>
          </div>
        </ng-container>

        <div class="invalid-feedback d-block" *ngIf="!page.comment && error">{{error}}</div>

        <div class="summary__buttons">
          <ion-button (click)="previous()">
            <ion-icon name="chevron-back-outline"></ion-icon>
            Back
          </ion-button>

          <ion-button (click)="next()" [disabled]="!questionForm.valid">
            Continue
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </ion-button>
        </div>

      </div>
    </div>
  </form>
</div>